export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12791.b1d16f1b.jpg";